













import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'customer-wishlist-banner',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  private showBanner: boolean = false;

  private get isLoggedIn(): boolean {
    return this.$store.getters['CheckoutGlobal/isLoggedIn'];
  }

  private get wishlistCount(): number {
    return this.$store.getters['CustomerWishlist/wishlistCount'];
  }
  private hideBanner(): void {
    this.showBanner = false;
  }

  @Watch('wishlistCount')
  private wishlistBannerAnimation(nv, ov): void {
    if (nv !== ov && this.showBanner === false) {
      this.showBanner = true;
      setTimeout(() => {
        this.showBanner = false;
      }, 8000);
    }
  }
}
